<template>
  <router-view />
</template>

<script>
export default {
  name: 'EquipmentStorageRentalsIndex'
}
</script>
